import { Options } from '@/components/Common/Selects/Select.types';
import { create } from 'zustand';

type ClassesStore = {
  selectedClassesValues: Options[] | null;
  setSelectedClassesValues: (classes: Options[] | null) => void;
};

export const useClassesStore = create<ClassesStore>()((set) => ({
  selectedClassesValues: null,
  setSelectedClassesValues: (selectedClassesValues) =>
    set({ selectedClassesValues }),
}));
